import type { PriceChecks, ProviderChecks } from "@/services/adminModelCurrency";
import { pricesPulledText, providerStatusText } from "./providerHelpers";

interface ProviderStatusLineProps {
  providers: ProviderChecks | null | undefined;
  prices: PriceChecks | null | undefined;
}

/** How each company's check went and when prices were last pulled; nothing when unknown. */
const ProviderStatusLine = ({ providers, prices }: ProviderStatusLineProps) => {
  const status = providerStatusText(providers);
  const pulled = pricesPulledText(prices?.fetchedAt);
  if (!status && !pulled) return null;
  return (
    <p className="flex flex-wrap gap-x-2 text-xs text-muted-foreground">
      {status ? <span>{status}</span> : null}
      {status && pulled ? <span aria-hidden="true">·</span> : null}
      {pulled ? <span>{pulled}</span> : null}
    </p>
  );
};

export default ProviderStatusLine;
